export default __webpack_public_path__ + "static/massage-22929127c582d61ec353926f1152e925.jpg";